import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { ApiService } from '../../services/api.service';
import { MODEL_OPTIONS, DEFAULT_MODEL, modelLabel } from '../../services/models';
import { RichEditorComponent } from '../../components/rich-editor';

@Component({
  selector: 'app-meeting-new',
  imports: [CommonModule, FormsModule, RichEditorComponent],
  templateUrl: './meeting-new.html',
  styleUrl: './meeting-new.scss'
})
export class MeetingNewComponent implements OnInit {
  step = 1;
  loading = false;
  loadingText = '';
  error = '';

  // Adım 1
  userName = localStorage.getItem('aidesk-user-name') || '';
  topic = '';
  meetingType = '';
  creditBudget = 50;
  model = DEFAULT_MODEL;
  modelOptions = MODEL_OPTIONS;
  meetingTypes: string[] = [];
  config: any = null;

  // Adım 2
  meetingId = 0;
  moderatorOpinion = '';
  suggestedType = '';
  experts: any[] = [];

  constructor(private api: ApiService, private router: Router) {}

  ngOnInit() {
    this.api.PostData('meeting/get-config', {}, (resp: any) => {
      this.config = resp;
      this.meetingTypes = resp.meetingTypes || [];
    });
  }

  get selectedModelDescription(): string {
    const o = this.modelOptions.find(x => x.value === this.model);
    return o ? o.description : '';
  }

  get selectedModelLabel(): string {
    return modelLabel(this.model);
  }

  // Konu artık HTML; boşluk/etiket temizlenmiş düz metni kontrol/gönderim için kullan.
  get topicText(): string {
    return (this.topic || '').replace(/<[^>]*>/g, ' ').replace(/&nbsp;/g, ' ').replace(/\s+/g, ' ').trim();
  }

  create() {
    if (!this.userName.trim()) { this.error = 'Lütfen adınızı yazın.'; return; }
    if (!this.topicText) { this.error = 'Lütfen toplantı konusunu yazın.'; return; }
    if (this.creditBudget < 1) { this.error = 'Bütçe en az 1 kredi olmalı.'; return; }
    this.error = '';
    this.loading = true;
    this.loadingText = 'Moderatör konuyu inceliyor ve uzman kadrosunu öneriyor...';

    localStorage.setItem('aidesk-user-name', this.userName.trim());

    this.api.PostData('meeting/create',
      { userName: this.userName.trim(), topic: this.topic.trim(), meetingType: this.meetingType || null, creditBudget: this.creditBudget, model: this.model },
      (resp: any) => {
        this.meetingId = resp.meetingId;
        // Bu tarayıcıyı toplantı sahibi katılımcı olarak işaretle (oda sayfası okur).
        localStorage.setItem('meeting-participant-' + resp.meetingId,
          JSON.stringify({ id: resp.participantId, name: this.userName.trim(), isOwner: true }));
        this.moderatorOpinion = resp.suggestion?.moderatorOpinion || '';
        this.suggestedType = resp.suggestion?.suggestedMeetingType || this.meetingType;
        this.experts = (resp.experts || []).map((e: any) => ({ ...e, include: true }));
        this.loading = false;
        this.step = 2;
      },
      (err: any) => {
        this.loading = false;
        this.error = 'Toplantı oluşturulamadı: ' + (err?.error?.exceptionMessage || err?.message || 'bilinmeyen hata');
      });
  }

  addExpert() {
    this.experts.push({
      code: 'UZMAN' + (this.experts.length + 1),
      name: '',
      title: '',
      rolePrompt: '',
      isRequired: false,
      include: true
    });
  }

  removeExpert(i: number) {
    this.experts.splice(i, 1);
  }

  get includedCount(): number {
    return this.experts.filter(e => e.include).length;
  }

  startMeeting() {
    const included = this.experts.filter(e => e.include);
    if (included.length < 2) { this.error = 'En az 2 uzman seçmelisiniz.'; return; }
    this.error = '';
    this.loading = true;
    this.loadingText = 'Uzmanlar kaydediliyor...';

    const payload = included.map((e, i) => ({
      code: e.code, name: e.name, title: e.title, rolePrompt: e.rolePrompt,
      isRequired: !!e.isRequired, isApproved: true, sortOrder: i
    }));

    this.api.PostData('meeting/save-experts', { meetingId: this.meetingId, experts: payload }, () => {
      // Bütçe adım 1'de create ile gitti ama kullanıcı adım 2'de değiştirmiş olabilir.
      this.api.PostData('meeting/set-budget', { meetingId: this.meetingId, creditBudget: this.creditBudget }, () => {
        this.loadingText = 'Moderatör toplantıyı açıyor...';
        this.api.PostData('meeting/start', { meetingId: this.meetingId }, () => {
          this.router.navigate(['/meeting', this.meetingId]);
        }, (err: any) => this.fail(err));
      }, (err: any) => this.fail(err));
    }, (err: any) => this.fail(err));
  }

  private fail(err: any) {
    this.loading = false;
    this.error = 'İşlem başarısız: ' + (err?.error?.exceptionMessage || err?.message || 'bilinmeyen hata');
  }
}
